import React from "react";
import { useTranslation } from "react-i18next";
import HardwareFeatures from "../HardwareFeatures";
import { SmartBandhardwareFeatures, colorTheme } from "./SmartBandData";

const SmartBandHardwareFeatures: React.FC = () => {
    const { t } = useTranslation("hardwareFeatures");

    return (
        <HardwareFeatures
            features={SmartBandhardwareFeatures}
            colorTheme={colorTheme}
            regularText={t("smartBand.regularText")}
            highlightedText={t("smartBand.highlightedText")}
            descriptionText={t("smartBand.descriptionText")}
        />
    );
};
export default SmartBandHardwareFeatures;